<template>
  <div class="GdPage">
    <div class="back" @click="goBack()">
      <div class="backIcon">
        <img src="../../assets/images/workOrderReview/back.png" alt="">
      </div>
      <div class="backText">{{$t('lang.UploadProof.Message')}}</div>
    </div>
    <Loadmore
      :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
      :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
      :bottomLoadingText="$t('lang.loadingStatus.loading')"
      :auto-fill="false"
      :bottom-method="getList"
      :bottom-all-loaded="hasLoadAll"
      ref="loadmore">
      <div class="listView">
        <div class="meassgeItem" v-for="(item,index) in list" :key="index" @click="gotoDeatil(item)">
          <div class="redIcon" v-if="item.UnreadMessageCount">
            {{item.UnreadMessageCount}}
          </div>
          <div class="messageIcon">
            <img v-if="item.MessageType === 'dialog'" src="../../assets/images/workOrderReview/message.png" alt="">
            <img v-else src="../../assets/images/workOrderReview/valume.png" alt="">
          </div>
          <div class="Content">
            <div class="row">
              <div class="title">{{$t('lang.UploadProofDetail.BillNumber')}}:{{item.TransactionUuid}}</div>
              <div class="createTime" v-if="messageValData!=={} && item.TicketId!==messageValData.TicketId">{{item.LastMessageTime}}</div>
              <div class="draft" v-else>[ {{$t('lang.UploadProof.Draft')}} ]</div>
            </div>
            <div class="row">
              <div class="issue">Issue:{{item.Issue}}</div>
            </div>
          </div>
        </div>
      </div>
    </Loadmore>

  </div>
</template>

<script>
import {Loadmore} from 'mint-ui'
import request from '@/service'
import showMore from '@/assets/images/common/showMore.gif'
export default {
  name: 'UploadproofDepositDetail',
  components: {
    Loadmore
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.Skip = 0
      vm.Take = 10
      vm.list = []
      vm.getList()
      let messageVal = JSON.parse(localStorage.getItem('messageVal'))
      let UserId = JSON.parse(localStorage.getItem('userInfo')).UserId
      if (messageVal && messageVal.UserId === UserId) {
        vm.messageValData = messageVal
      }
    })
  },
  data () {
    return {
      messageValData: {},
      Skip: 0,
      Take: 10,
      check: 0,
      list: [],
      hasLoadAll: true,
      firstLoad: true,
      showMore
    }
  },
  watch: {
    '$store.state.locale': function () {

    }
  },
  mounted () {

  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getList () {
      let url = 'innovation/unread/ticket/list'
      let data = {
        Skip: this.Skip,
        Take: this.Take,
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request('post', url, data, false).then(res => {
        if (res) {
          // this.list = res.TicketList
          if (this.check > 0) {
            this.list = res.TicketList
          } else {
            this.list = this.list.concat(res.TicketList)
          }
          this.Skip += this.Take
          this.hasLoadAll = this.Skip >= res.Total
          if (!this.firstLoad) {
            this.$refs.loadmore.onBottomLoaded()
          }
          this.firstLoad = false
          this.check = 0
        }
      }).catch(err => {
        console.log(err)
      })
    },
    gotoDeatil (item) {
      sessionStorage.setItem('DetailShowType', 2)
      sessionStorage.setItem('TransactionData', JSON.stringify(item))
      if (item.TicketType === 'deposit') {
        this.$router.push('UploadproofDepositDetail')
      } else {
        this.$router.push('UploadproofWithdrawDetail')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* 通用样式 */
input::placeholder {
  color: #464646;
  opacity: 1; /* 可选：设置placeholder文本的不透明度 */
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-input-placeholder {
  color: #464646;
}
.GdPage {
  position: relative;
  top: -10px;
  height: 100vh;
  overflow-y: hidden;
  .back{
    height: 6.11vw;
    display: flex;
    align-items: center;
    margin-top: 22vw;

    .backIcon{
      margin-left: 5vw;

    }
    .backText{
      margin-left: 5vw;
      color: #F6D9AA;
      font-weight: 700;
      font-size: 5.27vw;
    }
  }

  .listView{
    margin-top: 6vw;
    //border: 1px solid red;
    height: 83vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    .meassgeItem{
      width: 91.07vw;
      height: 19.166vw;
      background-color: rgb(34,34,34);
      border-radius: 2vw;
      margin-bottom: 3vw;
      display: flex;
      align-items: center;
      padding: 2vw;
      position: relative;
      flex: none;
      .redIcon{
        position: absolute;
        background-color: rgb(242,48,66);
        color: #fff;
        height: 4.444vw;
        width: 4.444vw;
        border-radius: 2.222vw;
        //display: flex;
        //align-items: center;
        //justify-content: center;
        font-size: 2.638vw;
        font-weight: 700;
        line-height: 4.444vw;
        text-align: center;
        top: 8.5vw;
        left: 84.5vw;
      }
      .messageIcon{
        //margin-left: 2vw;
      }
      .Content{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        flex: 1;
        margin-left: 2vw;
        height: 100%;
        .row{
          display: flex;
          align-items: center;
          justify-content: space-between;
          //border: 1px solid red;
          width: 100%;
          .issue{
            width: 70vw;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .title{
            font-size: 4vw;
            color: #fff;
            //border: 1px solid red;
            width: 45.5vw;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 700;
            letter-spacing: 0.1vw;
          }
          .createTime{
            color: #5F5F5F;
            font-size: 3vw;
            width: 33vw;
            text-align: right;
            padding-right: 3vw;
            //margin-top: 2vw;
          }
          .draft{
            color: #D1B68A;
            font-size: 3.333vw;
            font-weight: 700;
            width: 33vw;
            text-align: right;
            padding-right: 3vw;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/workOrderReview/workOrderMessage.vue